module.exports = __webpack_public_path__ + "static/media/strongbox.adf951c9.svg";